import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-transaction-complete",
    templateUrl: "./transaction-complete.component.html",
    styleUrls: ["./transaction-complete.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class TransactionCompleteComponent implements OnInit {
  constructor(
    private transactionDialog: MatDialogRef<TransactionCompleteComponent>,
    private authService: AuthService,
    public translate: TranslateService
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {}

  proceedNextAction() {
    this.transactionDialog.close();
  }
}
